import Profile from './profile';

class User {
  constructor(userId, profile) {
    this.userId = userId;
    this._profile = profile;
  }

  getProfile() {
    return this._profile;
  }

  isManager() {
    return this._profile.role === Profile.ROLE_MANAGER;
  }

  hasDelegation() {
    return !!this._profile.delegation;
  }

}

export default User;



// WEBPACK FOOTER //
// ./client/app/common/domain/models/user.js